function runCounters() {
    const $counters = $('.js-count');

    $counters.each(function () {
        const $el = $(this);
        const raw = $el.text();
        const num = parseFloat(String(raw).replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;

        $el.prop('Counter', 0).text('0').animate(
            { Counter: num },
            {
                duration: 3000,
                easing: 'linear',
                step(now) {
                    if (String(raw).includes('.')) {
                        $el.text((Math.ceil(now * 10) / 10).toFixed(1));
                    } else {
                        $el.text(Math.ceil(now));
                    }
                }
            }
        );
    });
}

function initCountersOnView() {
    const section = document.querySelector('[data-stats-section]');
    if (!section) return;

    if (!('IntersectionObserver' in window)) {
        runCounters();
        return;
    }

    const observer = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    runCounters();
                    obs.disconnect();
                }
            });
        },
        { threshold: 0.3 }
    );

    observer.observe(section);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountersOnView);
} else {
    initCountersOnView();
}
